module.exports = __webpack_public_path__ + "img/SM.494ff576.svg";